export const skills = [
    {
        id: "react",
        title: "React",
    },
    {
        id: "html",
        title: "HTML",
    },
    {
        id: "css",
        title: "CSS",
    },
];

export const reactPortfolio = [
    {
        id: 1,
        title: "Monsters rolodex app ",
        img: "assets/monster_rolodex.png",
        url: "https://github.com/ZhenyaKu/monsters-rolodex",
    },
    {
        id: 2,
        title: "ToDo list",
        img: "assets/todo_list.png",
        url: "https://github.com/ZhenyaKu/todo-list-react",
    },
    {
        id: 3,
        title: "E-commerce web-site",
        img: "assets/e-commerce.png",
        url: "https://github.com/ZhenyaKu/crwn-clothing",
    },
    {
        id: 4,
        title: "Calculator",
        img: "assets/calculator.png",
        url: "https://github.com/ZhenyaKu/calculator-react-hooks",
    },
    {
        id: 5,
        title: "Weather app ",
        img: "assets/weather_app.png",
        url: "https://github.com/ZhenyaKu/weather-app-react ",
    },
    {
        id: 6,
        title: "Chat app ",
        img: "assets/chat_app.png",
        url: "https://github.com/ZhenyaKu/simple-chat",
    },
    {
        id: 7,
        title: "Movie app ",
        img: "assets/movie_app.png",
        url: "https://github.com/ZhenyaKu/simple-chat",
    }
];

export const htmlPortfolio = [
    {
        id: 1,
        title: "Landing page",
        img: "assets/moshify.png",
        url: "https://github.com/ZhenyaKu/landing-page-moshify",
    },
];

export const cssPortfolio = [
    {
        id: 1,
        title: "Image gallery",
        img:
            "assets/image_gallery.png",
        url: "https://github.com/ZhenyaKu/image-gallery-grid",
    },
    {
        id: 2,
        title: "Recipe art page",
        img:
            "assets/recipe.png",
        url: "https://github.com/ZhenyaKu/recipe-art-pages",
    },
];

